import React, { useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './AdminLayout.css';

const AdminLayout = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      navigate('/login');
      return;
    }
    if (user && user.role !== 'admin') {
      navigate('/dashboard');
    }
  }, [user, loading, navigate]);

  if (loading || !user || user.role !== 'admin') {
    return (
      <div className="admin-layout admin-layout--loading">
        <div className="spinner" />
      </div>
    );
  }

  const navItems = [
    { to: '/admin', end: true, label: 'Overview', icon: '◉' },
    { to: '/admin/users', end: false, label: 'Users', icon: '👥' },
    { to: '/admin/repositories', end: false, label: 'Repositories', icon: '📦' },
    { to: '/admin/access-requests', end: false, label: 'Access Requests', icon: '🔐' },
    { to: '/admin/activity-logs', end: false, label: 'Activity Logs', icon: '📋' },
    { to: '/admin/access-matrix', end: false, label: 'Access Matrix', icon: '🗂️' },
    { to: '/admin/access-reviews', end: false, label: 'Access Reviews', icon: '✅' },
    { to: '/admin/policies', end: false, label: 'Policies', icon: '📜' },
    { to: '/admin/security', end: false, label: 'Security', icon: '🛡️' },
    { to: '/admin/analytics', end: false, label: 'Analytics', icon: '📊' },
    { to: '/admin/jobs', end: false, label: 'Jobs & API', icon: '⚙️' },
    { to: '/admin/integrations', end: false, label: 'Integrations', icon: '🔗' },
  ];

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <h2 className="admin-sidebar-title">Admin</h2>
          <p className="admin-sidebar-subtitle">Manage everything</p>
        </div>
        <nav className="admin-sidebar-nav">
          {navItems.map(({ to, end, label, icon }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `admin-sidebar-link ${isActive ? 'admin-sidebar-link--active' : ''}`
              }
            >
              <span className="admin-sidebar-link-icon">{icon}</span>
              <span className="admin-sidebar-link-label">{label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>
      <div className="admin-main">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
